export default __webpack_public_path__ + "static/media/analytical_chemistry_2021_774x250.d9c33812.jpg";